import { render, staticRenderFns } from "./SingleRelease.vue?vue&type=template&id=c02ab628&"
import script from "./SingleRelease.vue?vue&type=script&lang=js&"
export * from "./SingleRelease.vue?vue&type=script&lang=js&"
import style0 from "./SingleRelease.vue?vue&type=style&index=0&id=c02ab628&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports